/**
 * OfflineBanner — Uygulama offline duruma geçince üstte kırmızı bar gösterir.
 *
 * Native (Capacitor Network) + Web (navigator.onLine + online/offline events)
 * her ikisinde de çalışır. `nativeHelpers.initNetworkListener` sarmalayıcısını kullanır.
 *
 * Mağazacı senaryosu: Kasa POS'ta wifi kesildiğinde, kullanıcı hemen görmeli.
 */
import { useEffect, useState } from "react";
import { WifiOff, Wifi } from "lucide-react";
import { initNetworkListener } from "../utils/nativeHelpers";

export default function OfflineBanner() {
  const [status, setStatus] = useState({ connected: true, connectionType: "unknown" });
  const [visibleRecoveryToast, setVisibleRecoveryToast] = useState(false);

  useEffect(() => {
    let cleanupPromise;
    let mounted = true;
    let previous = true;

    cleanupPromise = initNetworkListener((s) => {
      if (!mounted) return;
      setStatus(s);
      // Offline'dan online'a döndüyse — 3sn "bağlantı geri geldi" toast'ı göster
      if (!previous && s.connected) {
        setVisibleRecoveryToast(true);
        setTimeout(() => setVisibleRecoveryToast(false), 3000);
      }
      previous = s.connected;
    });

    return () => {
      mounted = false;
      Promise.resolve(cleanupPromise).then((cleanup) => {
        if (typeof cleanup === "function") cleanup();
      });
    };
  }, []);

  if (status.connected && !visibleRecoveryToast) return null;

  if (visibleRecoveryToast) {
    return (
      <div
        className="fixed top-2 left-1/2 -translate-x-1/2 z-[9999] bg-emerald-500 text-white px-4 py-2 rounded-full shadow-lg flex items-center gap-2 text-sm font-medium animate-pulse"
        data-testid="online-recovery-toast"
      >
        <Wifi className="w-4 h-4" />
        Bağlantı geri geldi
      </div>
    );
  }

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[9999] bg-rose-600 text-white px-4 py-2 text-center text-sm font-medium flex items-center justify-center gap-2 shadow-lg"
      data-testid="offline-banner"
      role="alert"
    >
      <WifiOff className="w-4 h-4" />
      <span>İnternet bağlantısı yok — Bazı özellikler çalışmayabilir</span>
    </div>
  );
}
